import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
import { OFFER_ANCHOR, PRODUCT } from '../data/constants';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const showTimer = window.setTimeout(() => setVisible(true), 4000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      timeout = window.setTimeout(() => {
        setIndex(i => (i + 1) % buyers.length);
        setVisible(true);
      }, 700);
    }, 11000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearInterval(cycle);
      window.clearTimeout(timeout);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  const offset = reduceMotion ? 0 : -24;
  return <AnimatePresence data-id="element-152" data-mp="163wcgqrtry1s">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      x: offset,
      scale: reduceMotion ? 1 : 0.97
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: offset,
      scale: reduceMotion ? 1 : 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-3 left-3 z-50 w-[270px] max-w-[calc(100vw-24px)] sm:bottom-5 sm:left-5 sm:w-[310px]" role="status" aria-live="polite" data-id="element-153" data-mp="115uy2j5cgmwn">
          <div className="relative rounded-lg border-2 border-gold bg-navy p-3 pr-7 shadow-[0_0_0_3px_rgba(242,106,15,0.9),0_16px_32px_-12px_rgba(7,28,51,0.7)]" data-id="element-154" data-mp="x5u5zvpbod74">
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-1.5 top-1.5 rounded p-1 text-steellight transition-colors duration-150 ease-out hover:text-white" data-id="element-155" data-mp="s8av95ru2ijx">
              <XIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-156" data-mp="2aqnv0ynp278i" />
            </button>
            <a href={OFFER_ANCHOR} className="flex items-start gap-2.5" data-id="element-157" data-mp="2fm36jjy8br1r">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-158" data-mp="2knsjj550iesh" />
              <div className="min-w-0" data-id="element-159" data-mp="1rylm69hanv8t">
                <p className="font-display text-[13px] font-semibold uppercase leading-tight text-white" data-id="element-160" data-mp="1rzmx8dyb8hqj">
                  {buyer.name} {buyer.flag} just purchased
                </p>
                <p className="mt-0.5 truncate text-[11px] font-bold uppercase tracking-wide text-gold" data-id="element-161" data-mp="21v82qm2l8051">
                  {PRODUCT}
                </p>
                <p className="mt-0.5 text-[10.5px] font-medium text-steellight" data-id="element-162" data-mp="197lrcrn4br7m">
                  {buyer.city}, {buyer.country} · a few minutes ago
                </p>
              </div>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}